import React, { useEffect } from 'react'

import { connect } from 'react-redux'

import { testimonialListSelector } from 'reduxModules/testimonials/selectors'
import { testimonialsDispatchers } from 'reduxModules/testimonials/dispatchers'

import SlideShow from '../../generic/SlideShow'
import { TestimonialBody } from '../../generic/Testimonial/index'

import './styles.css'

function TestimonialCarousel(props) {
  const settings = {
    className: 'center',
    centerMode: false,
    infinite: true,
    slidesToShow: 1,
    speed: 1000,
    arrows: !props.isMobile,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true
  }
  useEffect(() => {
    props.loadRandomTestimonials()
  }, [])
  return (
    <section id="TestimonialCarousel" className="wrapper">
      <SlideShow {...settings}>
        {props?.testimonials?.results?.map((t, index) => (
          <TestimonialBody
            fullName={t?.fullName}
            text={t?.text}
            key={t?.id || index}
          />
        ))}
      </SlideShow>
    </section>
  )
}

export default connect(
  testimonialListSelector,
  testimonialsDispatchers
)(TestimonialCarousel)
